// Just enough JWT reading to know when a token runs out. The signature is the server's business;
// this only decides whether it is worth asking for a new one yet.

const decodePayload = (token) => {
  if (typeof token !== "string") return null

  const payload = token.split(".")[1]
  if (!payload) return null

  try {
    // base64url, so restore the standard alphabet and the padding atob insists on.
    const base64 = payload.replace(/-/g, "+").replace(/_/g, "/")
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), "=")
    return JSON.parse(decodeURIComponent(escape(window.atob(padded))))
  } catch {
    return null
  }
}

/**
 * When the token expires, in epoch milliseconds, or null when that cannot be read - callers treat
 * null as "no idea, so refresh rather than assume".
 */
export const expiresAt = (token) => {
  const exp = decodePayload(token)?.exp
  return typeof exp === "number" ? exp * 1000 : null
}
